import http from '@/utils/http'
import { ILoginReq, ILoginRes } from '@/types/user'
// import { IAccountSimpleVO } from './types';

/**
 * 用户相关Api
 */
let userApi = {

    /**
     * 登录
     */
    getCurrentUserInfo() {
        return http.post<any>('/common/user/details', {})
    },

    // test(activateKey: string) {
    //     return http.get<IAccountSimpleVO>('/account/login/activateAccount')
    // }
  /**
   * 获取通信秘钥信息
   */
  getStsAccessKeyInfo(params: any) {
      return http.post<any>('/common/sts/getStsAccessKeyInfo', params)
  }
}

export default userApi
